"use client";

import React from "react";
import PropTypes from "prop-types";

export default function ClientProviders({ children }) {
  return <>{children}</>;
}

// Validation des props
ClientProviders.propTypes = {
  children: PropTypes.node.isRequired,
};
